import React, { useEffect, useState } from 'react';
import './VendorManagement.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const getAuthHeaders = (headers = {}) => {
  const token = localStorage.getItem('authToken');
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
};

const formatMedian = (value) => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const amount = Number(value);
  return Number.isNaN(amount) ? String(value) : amount.toFixed(1);
};

const EnginePriceMatrix = () => {
  const [matrix, setMatrix] = useState({ columns: [], rows: [], count: 0 });
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadMatrix();
  }, []);

  const loadMatrix = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/engine-prices/matrix`, {
        headers: getAuthHeaders(),
      });
      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.error || 'Erreur lors du chargement de la matrice prix moteur');
      }

      setMatrix(data.data || { columns: [], rows: [], count: 0 });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setExporting(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/engine-prices/export`, {
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l export Excel');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const contentDisposition = response.headers.get('Content-Disposition') || '';
      const match = contentDisposition.match(/filename="?([^"]+)"?/i);
      const filename = match?.[1] || 'prix_moteur.xlsx';

      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="vendor-management">
      <h2>Prix Moteur</h2>

      {error && <div className="error-message">{error}</div>}

      <div className="search-bar">
        <button className="btn btn-primary" onClick={loadMatrix} disabled={loading}>
          {loading ? 'Chargement...' : 'Actualiser'}
        </button>
        <button className="btn btn-success" onClick={handleExport} disabled={exporting || loading}>
          {exporting ? 'Export...' : 'Exporter .xlsx'}
        </button>
      </div>

      {loading ? (
        <div className="loading">Chargement de la matrice...</div>
      ) : matrix.rows.length === 0 ? (
        <p className="no-data">Aucune donnee disponible pour calculer les medianes.</p>
      ) : (
        <div className="vendors-list">
          <table className="vendors-table">
            <thead>
              <tr>
                {matrix.columns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {matrix.rows.map((row) => (
                <tr key={row.moteur}>
                  <td>{row.moteur}</td>
                    <td>{formatMedian(row.prixConcurrent)}</td>
                    <td>{row.stockConcurrent || '-'}</td>
                    <td>{formatMedian(row.prixOpisto)}</td>
                    <td>{row.stockOpisto || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EnginePriceMatrix;
